"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var numberMeasure_1 = require("../measure/numberMeasure");
exports.createBaseUnits = function (MeasureType) { return ({
    meters: MeasureType.dimension("length", "m"),
    kilograms: MeasureType.dimension("mass", "kg"),
    seconds: MeasureType.dimension("time", "s"),
    amperes: MeasureType.dimension("current", "A"),
    kelvin: MeasureType.dimension("temperature", "K"),
    moles: MeasureType.dimension("substance", "mol"),
    candelas: MeasureType.dimension("intensity", "cd"),
    radians: MeasureType.dimension("planeAngle", "rad"),
    steradians: MeasureType.dimension("solidAngle", "sr"),
    bits: MeasureType.dimension("memory", "b"),
}); };
exports.meters = (_a = exports.createBaseUnits(numberMeasure_1.Measure), _a.meters), exports.kilograms = _a.kilograms, exports.seconds = _a.seconds, exports.amperes = _a.amperes, exports.kelvin = _a.kelvin, exports.moles = _a.moles, exports.candelas = _a.candelas, exports.radians = _a.radians, exports.steradians = _a.steradians, exports.bits = _a.bits;
//# sourceMappingURL=base.js.map